module.exports = __webpack_public_path__ + "assets/img/wh5_p08.f59d6f22.png";